const features = [
  {
    icon: 'ri-article-line',
    title: '下拉式阅读',
    desc: '极致的纵向滚动阅读体验，无需翻页点击，一口气畅读全集不中断。加载迅速流畅，专为漫画阅读场景深度优化。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '全站零广告干扰，高清画质原汁原味呈现漫画细节。没有弹窗、没有贴片广告，只有纯粹的阅读享受。',
  },
  {
    icon: 'ri-global-line',
    title: '三漫合一',
    desc: '日漫、韩漫、国漫大全会集于一个平台，无需切换多个网站。每日实时同步各大平台最新连载，追更快人一步。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            古古漫画网为漫画爱好者打造的三大核心体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 text-center hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100">
                <i className={`${feat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}